var exports = {
  "k": "xe533113f--3178b2--container",
};

module.exports = exports;
